export default "/assets/images/pet-dander-video.mp4?752232510d7e273d267d2ff4f057b9c5";